import { useState } from "react";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import MiniSpinner from "../ui/MiniSpinner";
import { BRAND, THEMES, STAFF, STAFF_COLORS } from "../../config/constants";
import { db } from "../../firebase";

export default function AssignTaskButton({ clientId, clientName, bizId, bizName, currentUser, theme }) {
  const t = THEMES[theme];
  const [show, setShow] = useState(false);
  const [toStaff, setToStaff] = useState("");
  const [message, setMessage] = useState("");
  const [sending, setSending] = useState(false);

  const send = async () => {
    if (!toStaff) return;
    setSending(true);
    try {
      await addDoc(collection(db, "tasks"), {
        clientId: clientId || null,
        clientName: clientName || "",
        bizId: bizId || null,
        bizName: bizName || "",
        fromStaff: currentUser,
        toStaff,
        message: message.trim(),
        status: "pending",
        createdAt: serverTimestamp(),
      });
      setShow(false); setToStaff(""); setMessage("");
    } catch(e) { alert("Failed: " + e.message); }
    setSending(false);
  };

  if (!show) return (
    <button onClick={() => setShow(true)}
      style={{ display:"flex", alignItems:"center", gap:5, padding:"6px 12px", borderRadius:8, background:"transparent", border:`1px solid ${t.border}`, cursor:"pointer", color:t.textSub, fontSize:12, fontWeight:600, fontFamily:"'Outfit',sans-serif" }}>
      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.18 11.9a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.11 1h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.09 8.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 21 16z"/></svg>
      Assign Task
    </button>
  );

  return (
    <div style={{ background:t.surface, border:`1px solid ${BRAND.blue}40`, borderRadius:12, padding:14, marginTop:8 }}>
      <div style={{ fontSize:12.5, fontWeight:700, color:t.text, marginBottom:10 }}>Assign to staff member</div>
      <div style={{ display:"flex", gap:6, marginBottom:10 }}>
        {STAFF.map(s=>(
          <button key={s} onClick={()=>setToStaff(s)} type="button"
            style={{ flex:1, padding:"6px 0", borderRadius:8, border:`2px solid ${toStaff===s?STAFF_COLORS[s]:t.border}`, background:toStaff===s?STAFF_COLORS[s]+"18":"transparent", color:toStaff===s?STAFF_COLORS[s]:t.textMuted, fontWeight:700, fontSize:12.5, cursor:"pointer", fontFamily:"'Outfit',sans-serif" }}>
            {s}
          </button>
        ))}
      </div>
      <textarea value={message} onChange={e=>setMessage(e.target.value)} placeholder="Add a note (optional)..."
        style={{ width:"100%", background:t.bg, border:`1px solid ${t.border}`, borderRadius:8, padding:"8px 10px", color:t.text, fontSize:12.5, outline:"none", fontFamily:"'Outfit',sans-serif", resize:"vertical", minHeight:60, boxSizing:"border-box", marginBottom:10 }}/>
      <div style={{ display:"flex", gap:8 }}>
        <button onClick={send} disabled={!toStaff||sending}
          style={{ ...{padding:"7px 18px",borderRadius:8,background:`linear-gradient(135deg,${BRAND.blue},#1a8bbf)`,border:"none",color:"#fff",fontSize:12,fontWeight:700,cursor:"pointer",fontFamily:"'Outfit',sans-serif"}, opacity:!toStaff?0.5:1 }}>
          {sending?<><MiniSpinner size={12} color="#fff"/>Sending...</>:"Send Task"}
        </button>
        <button onClick={()=>setShow(false)} style={{ padding:"7px 12px", borderRadius:8, background:"transparent", border:`1px solid ${t.border}`, color:t.textMuted, fontSize:12, cursor:"pointer", fontFamily:"'Outfit',sans-serif" }}>Cancel</button>
      </div>
    </div>
  );
}

// ─── Task System ──────────────────────────────────────────────────────────────

// Task Detail Modal
